module.exports = __webpack_public_path__ + "img/q2-5.1dc9a001.png";